import type { User } from "../../../slices/authSlice"
import ApplicantSection from "./ApplicantSection"
import RepresentativeSection from "../representative/RepresentativeSection"
import SectionHeader from "../../ui/SectionHeader"
import { FiUsers } from "react-icons/fi"
import PriorApplicationImportButton from "../../ui/PriorApplicationImportButton"

type WrapperProps = {
  hideHeader?: boolean
  onApplicantChange: (value: any) => void
  orderingParty?: Partial<User> | null
  initialData?: any[]
  disabled?: boolean
  representativeOffice?: string
  importSource?: "trademark" | "design"
  currentApplicationId?: string | null
  ownerUserId?: string | null
}

export default function ApplicantAndRepresentativeWrapper({
  hideHeader = false,
  onApplicantChange,
  initialData,
  orderingParty,
  disabled = false,
  representativeOffice,
  importSource,
  currentApplicationId,
  ownerUserId
}: WrapperProps) {

  const applicantKey = (applicant: any) => JSON.stringify({
    type: applicant?.type || "",
    firstName: applicant?.firstName || "",
    lastName: applicant?.lastName || "",
    legalName: applicant?.legalName || applicant?.organisationName || "",
    address: applicant?.address || {},
    contact: applicant?.contact || {}
  })

  const handleImportApplicants = (importedApplicants: any[]) => {
    const existingApplicants = initialData || []
    const existingKeys = new Set(existingApplicants.map(applicantKey))
    const uniqueImportedApplicants = importedApplicants.filter((applicant) => {
      const key = applicantKey(applicant)
      if (existingKeys.has(key)) return false
      existingKeys.add(key)
      return true
    })

    if (uniqueImportedApplicants.length === 0) return false

    onApplicantChange([...existingApplicants, ...uniqueImportedApplicants])
    return true
  }

  return (
    <div id="applicant" className="scroll-mt-28 border-t border-gray-300 pt-4">

      {!hideHeader && (
        <SectionHeader
          icon={<FiUsers size={20} />}
          title="Applicant and Representative"
          subtitle="Provide information about the applicant(s) and representative(s)."
          action={
            importSource ? (
              <PriorApplicationImportButton
                source={importSource}
                target="applicants"
                currentApplicationId={currentApplicationId}
                ownerUserId={ownerUserId}
                disabled={disabled}
                hasCurrentData={Boolean(initialData?.length)}
                mode="append"
                onImport={handleImportApplicants}
              />
            ) : undefined
          }
        />
      )}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ApplicantSection
          orderingParty={orderingParty}
          hideHeader={true}
          onChange={onApplicantChange}
          initialData={initialData}
          disabled={disabled}
        />

        <RepresentativeSection disabled={disabled} officeLabel={representativeOffice} />
      </div>
    </div>
  )
}